export const ArrowDownIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00049 0.25L11.6914 5.94092L10.2852 7.34717L6.00049 3.0625L1.71582 7.34717L0.309571 5.94092L6.00049 0.25Z"
      fill="currentColor"
    />
  </svg>
);
